export default __webpack_public_path__ + "static/media/home_carousel_2.cc9de8c1.png";